import { ColDef } from 'ag-grid-enterprise';
import { format } from 'date-fns';
import { PortfolioCompanyResponse } from '~/api/def/endpoints/portfolioCompanyEndpoint';
import { PortfolioLinkCell } from './PortfolioLinkCell';

export const colDefsPortfoliosTableGet = (
  fundId?: string,
  fundName?: string,
): ColDef<PortfolioCompanyResponse>[] => [
  {
    field: 'name',
    headerName: 'Name',
    cellRenderer: (p: { value: string; data: PortfolioCompanyResponse }) =>
      PortfolioLinkCell({
        ...p,
        fundId: fundId,
        fundName: fundName,
      }),
    sortable: true,
    type: 'w200',
    autoHeight: true,
    cellClass: 'flex align-items-center justify-content-left',
    wrapText: true,
  },
  {
    field: 'companyStatus',
    headerName: 'Status',
    sortable: true,
    cellClass: 'flex align-items-center justify-content-left',
    type: 'w120',
    filter: true,
  },
  {
    field: 'fundName',
    headerName: 'Fund Name',
    sortable: true,
    cellClass: 'flex align-items-center justify-content-left',
    type: 'w120',
    filter: 'agSetColumnFilter',
  },
  {
    field: 'incorporationDate',
    headerName: 'Incorporation Date',
    filter: 'agDateColumnFilter',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    type: 'w200',
    sortable: true,
    valueFormatter: (p) => (p.value ? format(p.value, 'yyyy-MM-dd') : '-'),
  },
  {
    field: 'currentRound',
    headerName: 'Current Round',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    type: 'w200',
    sortable: true,
    filter: true,
  },
  {
    field: 'sectorName',
    headerName: 'Sector',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    type: 'w200',
    sortable: true,
    filter: true,
  },
  {
    field: 'pCValuations',
    headerName: 'Initial Investment',
    cellClass: 'flex align-items-center justify-content-right',
    type: 'w200',
    sortable: true,
    filter: 'agNumberColumnFilter',
    valueGetter: (params) => {
      return params.data?.pCValuations[0]?.initialInvestmentByFund;
    },
    valueFormatter: (params) => {
      return params.value
        ? new Intl.NumberFormat('en-GB').format(params.value)
        : '-';
    },
  },
  {
    field: 'pCValuations',
    headerName: 'Follow-on',
    cellClass: 'flex align-items-center justify-content-right',
    type: 'w200',
    sortable: true,
    filter: 'agNumberColumnFilter',
    valueGetter: (params) => {
      return params.data?.pCValuations[0]?.followOnByFund;
    },
    valueFormatter: (params) => {
      return params.value
        ? new Intl.NumberFormat('en-GB').format(params.value)
        : '-';
    },
  },

  {
    field: 'pCValuations',
    headerName: 'Total Raised',
    cellClass: 'flex align-items-center justify-content-right',
    type: 'w200',
    sortable: true,
    filter: 'agNumberColumnFilter',
    valueGetter: (params) => {
      return params.data?.pCValuations[0]?.totalRaised;
    },
    valueFormatter: (params) => {
      return params.value
        ? new Intl.NumberFormat('en-GB').format(params.value)
        : '-';
    },
  },
  {
    field: 'incorporationDate',
    headerName: 'Holding Period',
    cellClass: 'flex align-items-center justify-content-right',
    type: 'w200',
    sortable: true,
    filter: 'agNumberColumnFilter',
    valueGetter: (params) => {
      if (!params.data?.incorporationDate) return null;
      const incorporationDate = new Date(params.data.incorporationDate);
      const today = new Date();
      const diffYears =
        (today.getTime() - incorporationDate.getTime()) /
        (1000 * 60 * 60 * 24 * 365.25);
      return Math.round(diffYears * 10) / 10; // Round to 1 decimal place
    },
    valueFormatter: (params) => {
      return params.value ? `${params.value}` : '-';
    },
  },
];
